import * as yup from 'yup';

export const initialValues = {
  sku: '',
  rfids: [''] as string[],
};

export const validationSchema = yup.object().shape({
  sku: yup.string().required('Required field'),
  rfids: yup.array().of(yup.string().required('Required field')).required(),
});
